import React, { Component } from "react"
import SubHeader from "../../header/SubHeaderView.js"
// import ViewModel from "./controllers/ViewModel.js"
import VouchersCanceladosV2View from "./views/VouchersCanceladosV2.js"

export default class VouchersCanceladosV2 extends Component {
  constructor(props) {
    super(props);
    // this.viewModel = new ViewModel();
    // this.viewModel.mirrorState = (s) => this.setState(s);
    // this.viewModel.props = props;
  }

  componentDidMount() {
    // this.viewModel.fetchData(this.props.childProps.user);
  }

  render() {
    return (
      <div className="page-content-wrapper">
        <SubHeader textoEsquerda="Relatórios" textoCentral="Cancelados" />
        <div className="page-content">
          <div className="container">
            <VouchersCanceladosV2View {...this.props}  />
          </div>
        </div>
      </div>
    );
  }
}
